import React, { useEffect, useMemo } from 'react';
import '../../styles/styles.scss';
import { FormattedMessage } from 'react-intl';
import MultiSelect from 'react-multi-select-component';
import Checkbox from 'react-three-state-checkbox';
import { getOrder } from './pages';

const MOBILE_APP_CATEGORY = 'MobileApp'

const FeedbackHeader = (params) => {
  const categoryOptions = useMemo(() => params.categories ? params.categories.map(category => ({
    label: params.intl.formatMessage({ id:'app.feedback.category.' + category.categoryCode}),
    value: category.categoryCode
  })) : [], [params.categories]);

  const selectedCategories = params.selectedCategories ?
    params.selectedCategories.map(value => ({value})) : [];

  const overrideStrings = {
    'selectAll': params.intl.formatMessage({ id:'multiSelectDropdown.selectAll'}),
  }

  useEffect(() => {
    if(categoryOptions &&
      categoryOptions.length &&
      (!params.selectedCategories ||
      params.selectedCategories.includes(MOBILE_APP_CATEGORY))) {
      params.selectCategory(categoryOptions.filter(c => c.value !== MOBILE_APP_CATEGORY))
    }
  }, [categoryOptions])

  return (
    <thead className="thead-light">
      <tr role="row">
        <th tabIndex="0" aria-controls="feedbackTable" rowSpan="1" colSpan="1" >
          <FormattedMessage id="app.feedback.header.id" />
        </th>
        <th tabIndex="0" aria-controls="feedbackTable" rowSpan="1" colSpan="1">
          <FormattedMessage id="app.feedback.header.rating" />
        </th>
        <th
          id="sort_by_userEmail"
          className={getOrder('userEmail', params.sortBy, params.sortDirection)}
          tabIndex="0"
          aria-controls="feedbackTable"
          rowSpan="1"
          colSpan="1"
          onClick={params.reload}>
          <FormattedMessage id="app.feedback.header.user" />
        </th>
        <th
          id="sort_by_countryCode"
          tabIndex="0"
          aria-controls="feedbackTable"
          rowSpan="1"
          colSpan="1">
          <FormattedMessage id="app.feedback.header.country" />
        </th>
        <th
          id="sort_by_createdAt"
          className={getOrder('createdAt', params.sortBy, params.sortDirection)}
          tabIndex="0"
          aria-controls="feedbackTable"
          rowSpan="1"
          colSpan="1"
          onClick={params.reload}>
          <FormattedMessage id="app.feedback.header.date" />
        </th>
        <th
          id="sort_by_vehicle.model"
          className={getOrder('vehicle.model', params.sortBy, params.sortDirection)}
          tabIndex="0"
          aria-controls="feedbackTable"
          rowSpan="1"
          colSpan="1"
          onClick={params.reload}
          style={{minWidth: '6rem'}}>
          <FormattedMessage id="app.feedback.header.vehicle" />
        </th>
        <th
          id="sort_by_vin"
          className={getOrder('vin', params.sortBy, params.sortDirection)}
          tabIndex="0"
          aria-controls="feedbackTable"
          rowSpan="1"
          colSpan="1"
          onClick={params.reload}>
          <FormattedMessage id="app.feedback.header.vin" />
        </th>
        <th
          id="categoryCode"
          className={getOrder('categoryCode', params.sortBy, params.sortDirection)}
          tabIndex="0"
          aria-controls="feedbackTable"
          rowSpan="1"
          colSpan="1" >
          <span id="sort_by_categoryCode" onClick={params.reload}><FormattedMessage id="app.feedback.header.category" /></span>
          <MultiSelect
            options={categoryOptions}
            value={selectedCategories}
            onChange={params.selectCategory}
            overrideStrings={overrideStrings}
            disableSearch={true}
          />
        </th>
        <th
          className={getOrder('comment', params.sortBy, params.sortDirection)}
          tabIndex="0"
          aria-controls="feedbackTable"
          rowSpan="1"
          colSpan="1"
          style={{width: '10rem'}}>
          <span id="sort_by_comment" onClick={params.reload}><FormattedMessage id="app.feedback.header.comment" /></span>
          <Checkbox
            className="triState"
            checked={params.withComment===true}
            indeterminate={params.withComment===null || params.withComment===undefined}
            onChange={params.selectComment}
          />
        </th>
        <th
          className={getOrder('adminReaction', params.sortBy, params.sortDirection)}
          tabIndex="0"
          aria-controls="feedbackTable"
          rowSpan="1"
          colSpan="1"
          style={{width: '10rem'}}>
          <span id="sort_by_adminReaction" onClick={params.reload}><FormattedMessage id="app.feedback.header.reaction" /></span>
          <Checkbox
            className="triState"
            checked={params.withReaction===true}
            indeterminate={params.withReaction===null || params.withReaction===undefined}
            onChange={params.selectReaction}
          />
        </th>
        <th tabIndex="0" aria-controls="feedbackTable" rowSpan="1" colSpan="1"  style={{minWidth: '2.8rem'}}>
          <FormattedMessage id="app.feedback.header.files" />
        </th>
        <th tabIndex="0" aria-controls="feedbackTable" rowSpan="1" colSpan="1" style={{minWidth: '5rem'}}>
          <FormattedMessage id="app.feedback.header.influence" />
        </th>
        <th tabIndex="0" aria-controls="feedbackTable" rowSpan="1" colSpan="1">
          <FormattedMessage id="app.feedback.header.cask" />
        </th>
        <th />
      </tr>
    </thead>
  );
};

export default FeedbackHeader;
